<div class="skl-users-sync" aria-busy="true" aria-label="Loading user sync information">
  <app-skeleton width="180px" height="18px" borderRadius="4px" marginBottom="20px" class="d-block"></app-skeleton>

  <div class="skl-card mb-20">
    <div class="skl-card__body">
      <app-skeleton width="170px" height="18px" borderRadius="4px" marginBottom="14px"></app-skeleton>
      <app-skeleton width="92%" height="13px" borderRadius="3px" marginBottom="8px"></app-skeleton>
      <app-skeleton width="78%" height="13px" borderRadius="3px" marginBottom="20px"></app-skeleton>

      <div class="skl-config-row">
        <div class="skl-config-field">
          <app-skeleton width="160px" height="13px" borderRadius="3px" marginBottom="10px"></app-skeleton>
          <app-skeleton width="100%" height="40px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-config-actions">
          <app-skeleton width="92px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
          <app-skeleton width="88px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
      </div>
    </div>
  </div>

  <div class="skl-card mb-20">
    <div class="skl-card__body">
      <app-skeleton width="120px" height="18px" borderRadius="4px" marginBottom="20px"></app-skeleton>

      <div class="skl-job-banner">
        <app-skeleton width="220px" height="14px" borderRadius="3px" marginBottom="10px"></app-skeleton>
        <app-skeleton width="70%" height="13px" borderRadius="3px" marginBottom="6px"></app-skeleton>
        <app-skeleton width="54%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>

      <div class="skl-status-grid">
        <div>
          @for (row of detailRows; track row) {
            <app-skeleton [width]="row === 1 ? '56%' : row === 2 ? '72%' : '64%'" height="13px" borderRadius="3px" marginBottom="12px"></app-skeleton>
          }
        </div>
        <div class="skl-status-action">
          <app-skeleton width="190px" height="42px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
      </div>

      <div class="skl-progress">
        <app-skeleton width="48%" height="13px" borderRadius="3px" marginBottom="12px"></app-skeleton>
        <app-skeleton width="100%" height="18px" borderRadius="999px" marginBottom="0"></app-skeleton>
      </div>
    </div>
  </div>

  <div class="skl-stats-grid mb-20">
    @for (card of summaryCards; track card) {
      <div class="skl-stat-card">
        <app-skeleton width="56%" height="14px" borderRadius="3px" marginBottom="10px"></app-skeleton>
        <app-skeleton width="44%" height="28px" borderRadius="4px" marginBottom="0"></app-skeleton>
      </div>
    }
  </div>

  <div class="skl-card">
    <div class="skl-card__body">
      <app-skeleton width="210px" height="18px" borderRadius="4px" marginBottom="14px"></app-skeleton>
      <app-skeleton width="68%" height="13px" borderRadius="3px" marginBottom="20px"></app-skeleton>

      <div class="skl-debug-grid">
        @for (col of debugCols; track col) {
          <div>
            <app-skeleton width="120px" height="13px" borderRadius="3px" marginBottom="10px"></app-skeleton>
            <app-skeleton width="100%" height="40px" borderRadius="4px" marginBottom="0"></app-skeleton>
          </div>
        }
      </div>

      <div class="skl-debug-action">
        <app-skeleton width="138px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
      </div>
    </div>
  </div>
</div>